import { render, staticRenderFns } from "./StoreSmallCard.vue?vue&type=template&id=3207fb22&scoped=true&"
import script from "./StoreSmallCard.vue?vue&type=script&lang=js&"
export * from "./StoreSmallCard.vue?vue&type=script&lang=js&"
import style0 from "./StoreSmallCard.vue?vue&type=style&index=0&id=3207fb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207fb22",
  null
  
)

export default component.exports